import React from "react";
import FieldTypesEnum from "../../Enums/FieldTypesEnum";
import TabListTableCellWidthEnum from "../../Enums/TabListTableCellWidthEnum";
import dateTimeHelper from "../../Helpers/datetimeHelper";
import DataTableActionMenu from '../../Elements/DataTable/DataTableActionMenu';
import urlHelper from '../../Helpers/urlHelper';
import AuthService from '../../Services/authService';
import LongText from '../../Elements/LongText';

export default class UrlShortenerItem
{
  constructor (item = {})
  {
    this.ShortUrlId = item.shortUrlId ?? '';
    this.ShortUrlString = item.shortUrlString ?? '';
    this.Target = item.target ?? '';
    this.Type = item.type ?? '';
    this.RedirectType = item.redirectType ?? '';
    this.CreateStats = item.createStats ?? true;
    this.IsActive = item.isActive ?? true;
    this.ExpirationDateUtc = item.expirationDateUtc ?? '';
    this.DeleteAfterExpirationDate = item.deleteAfterExpirationDate ?? true;
    this.HitCount = item.hitCount ?? 0;
    this.LastAccessedUtc = item.lastAccessedUtc ?? '';
    this.Notes = item.notes ?? '';
    this.Tags = item.tags ?? '';
    this.CreatedBy = item.createdBy ?? '';
    this.ModifiedBy = item.modifiedBy ?? '';
    this.CreatedOnUtc = item.createdOnUtc ?? '';
    this.ModifiedOnUtc = item.modifiedOnUtc ?? '';
  }

  static NameOfTheIdField ()
  {
    return 'ShortUrlId';
  }
  static nameOfTheItemDetailList ()
  {
    return 'Short URL';
  }

  static MoneyFields = [];

  static Currency ()
  {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary ()
  {
    return '';
  }

  static DateFields = [ 'ExpirationDateUtc', 'LastAccessedUtc', 'CreatedOnUtc', 'ModifiedOnUtc' ];

  static BoolFields = [ 'CreateStats', 'IsActive', 'DeleteAfterExpirationDate' ];

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        { name: 'ShortUrlId', label: 'ID' },
        { name: 'ShortUrlString', label: 'Short URL' },
        { name: 'IsActive', label: 'Active' },
        { name: UrlShortenerItem.getLongLink, label: 'Link', width: TabListTableCellWidthEnum.Full },
        { name: 'Target', label: 'Target URL', width: TabListTableCellWidthEnum.Full },
        // { name: 'Type', label: 'Type' },
        // { name: 'RedirectType', label: 'Redirect Type' },
        { name: 'HitCount', label: 'Hit Count' },
        { name: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.ExpirationDateUtc), label: 'Expiration Date' },
        { name: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.LastAccessedUtc), label: 'Last Accessed' },
        { name: 'Notes', label: 'Notes', width: TabListTableCellWidthEnum.TwoLines },
        { name: 'Tags', label: 'Tags' },
        { name: 'CreatedBy', label: 'Created By' },
        { name: 'ModifiedBy', label: 'Modified By' },
        { name: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.CreatedOnUtc), label: 'Created On' },
        { name: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.ModifiedOnUtc), label: 'Modified On' },
      ],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable ()
  {
    return [
      {
        label: 'ID',
        orderById: 'ShortUrlId',
        data: 'ShortUrlId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 50,
        className: 'text-left',
      },
      {
        label: 'Short URL',
        orderById: 'ShortUrlString',
        data: UrlShortenerItem.getShortLink,
        type: FieldTypesEnum.PureDataField,
        className: 'text-left',
      },
      {
        label: 'Target URL',
        orderById: 'Target',
        data: (item) => (
          <LongText
            text={item.Target}
            maxLength={50}
          />
        ),
        type: FieldTypesEnum.PureDataField,
        className: 'text-left',
      },
      // { label: 'Type', orderById: 'Type', data: 'Type', type: FieldTypesEnum.PureDataField, className: 'text-left' },
      // {
      //   label: 'Redirect Type',
      //   orderById: 'RedirectType',
      //   data: 'RedirectType',
      //   type: FieldTypesEnum.PureDataField,
      //   className: 'text-left',
      // },
      {
        label: 'Active',
        orderById: 'IsActive',
        data: 'IsActive',
        type: FieldTypesEnum.PureDataField,
        className: 'text-left',
      },
      {
        label: 'Hit Count',
        orderById: 'HitCount',
        data: 'HitCount',
        type: FieldTypesEnum.PureDataField,
        className: 'text-left',
      },
      {
        label: 'Expiration Date',
        orderById: 'ExpirationDateUtc',
        data: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.ExpirationDateUtc),
        minWidth: 50,
        className: 'text-left',
      },
      // {
      //   label: 'Last Accessed',
      //   orderById: 'LastAccessedUtc',
      //   data: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.LastAccessedUtc),
      //   minWidth: 50,
      //   className: 'text-left',
      // },
      // {
      //   label: 'Notes',
      //   orderById: 'Notes',
      //   data: 'Notes',
      //   type: FieldTypesEnum.PureDataField,
      //   minWidth: 20,
      //   className: 'text-left',
      // },
      { label: 'Tags', orderById: 'Tags', data: 'Tags', type: FieldTypesEnum.PureDataField, className: 'text-left' },
      // {
      //   label: 'Created By',
      //   orderById: 'CreatedBy',
      //   data: 'CreatedBy',
      //   type: FieldTypesEnum.PureDataField,
      //   className: 'text-left',
      // },
      // {
      //   label: 'Modified By',
      //   orderById: 'ModifiedBy',
      //   data: 'ModifiedBy',
      //   type: FieldTypesEnum.PureDataField,
      //   className: 'text-left',
      // },
      // {
      //   label: 'Created On',
      //   orderById: 'CreatedOnUtc',
      //   data: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.CreatedOnUtc),
      //   minWidth: 50,
      //   className: 'text-left',
      // },
      // {
      //   label: 'Modified On',
      //   orderById: 'ModifiedOnUtc',
      //   data: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.ModifiedOnUtc),
      //   minWidth: 50,
      //   className: 'text-left',
      // },
      {
        label: ' ',
        orderById: '',
        data: UrlShortenerItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        minWidth: 50,
      },
    ];
  }

  static getActionsContent (item)
  {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            disabled: item.StatusCode === 5,
            onClick: () => UrlShortenerItem.editFunction(item.ShortUrlId, item),
          },
        ]}
      />
    );
  }

  static getRealUrl (item)
  {
    const authContext = AuthService.getInstance();
    const environment = authContext.GetEnvironment();
    let baseUrl =
      environment === 'development'
        ? `${authContext.GetApiUrl()}sh` //Development
        : environment === 'staging' || environment === 'UAT'
          ? 'https://shstage.baidata.com' //Stage
          : 'https://sh.baidata.com'; //Prod
    if (baseUrl.endsWith('/'))
    {
      baseUrl = baseUrl.slice(0, -1);
    }
    return `${baseUrl}/${item.ShortUrlString}`;
  }

  static getLongLink (item)
  {
    const realUrl = UrlShortenerItem.getRealUrl(item);
    return urlHelper.getLinkComponent(realUrl, realUrl, null, 'Click to open the short URL on a new tab');
  }

  static getShortLink (item)
  {
    const realUrl = UrlShortenerItem.getRealUrl(item);
    return urlHelper.getLinkComponent(item.ShortUrlString, realUrl, null, 'Click to open the short URL on a new tab');
  }

  static editFunction = (id, item, itemList) =>
  {
    alert('Empty function');
  };
}
